import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowSquareLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10.03 9.47a.75.75 0 0 1 0 1.06l-.72.72h7.19a.75.75 0 0 1 0 1.5H9.31l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1-.22-.528v-.004c0-.191.074-.382.22-.528l2-2a.75.75 0 0 1 1.06 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0 3.739 0 5.608.804 7A6 6 0 0 0 5 21.196C6.392 22 8.262 22 12 22s5.608 0 7-.804A6 6 0 0 0 21.196 19C22 17.608 22 15.739 22 12s0-5.608-.804-7A6 6 0 0 0 19 2.804C17.608 2 15.739 2 12 2s-5.608 0-7 .804A6 6 0 0 0 2.804 5C2 6.392 2 8.262 2 12m17.897-6.25c.248.43.418 1.001.509 2.006.093 1.025.094 2.347.094 4.244s-.001 3.22-.094 4.244c-.091 1.005-.26 1.576-.509 2.006a4.5 4.5 0 0 1-1.647 1.647c-.43.248-1.001.418-2.006.509-1.025.093-2.347.094-4.244.094s-3.22-.001-4.244-.094c-1.005-.091-1.576-.26-2.006-.509a4.5 4.5 0 0 1-1.647-1.647c-.248-.43-.418-1.001-.509-2.006C3.501 15.22 3.5 13.897 3.5 12s.001-3.22.094-4.244c.091-1.005.26-1.576.509-2.006A4.5 4.5 0 0 1 5.75 4.103c.43-.248 1.001-.418 2.006-.509C8.78 3.501 10.103 3.5 12 3.5s3.22.001 4.244.094c1.005.091 1.576.26 2.006.509a4.5 4.5 0 0 1 1.647 1.647"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowSquareLeft;
